/**
 * 标签纠正模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const correctStandardTagValueConfiguration = {
  //去重校验
  duplicatesVerify(params) {
    return $http.post(`${global.API_URL}/sme/correctStandardTagValueConfiguration/duplicatesVerify`,params);
  },
  //分页
  pagingQuery(params) {
    return $http.post(`${global.API_URL}/sme/correctStandardTagValueConfiguration/pagingQuery`,params);
  },
  //更新
  update(params) {
    return $http.post(`${global.API_URL}/sme/correctStandardTagValueConfiguration/update`,params);
  },
  //新增
  create(params) {
    return $http.post(`${global.API_URL}/sme/correctStandardTagValueConfiguration/create`,params);
  },
  //删除
  delete(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/correctStandardTagValueConfiguration/delete`,param);
  },
  //查询标准标签key列表
  getStandardTagListByCompanyId(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/standardTagKey/getStandardTagListByCompanyId`,param);
  },
  //查询tag key关联的value 列表
  listStandardTagKeyValueRelationByStandardTagKeyId(params) {
    return $http.post(`${global.API_URL}/sme/standardTagKeyValueRelation/listStandardTagKeyValueRelationByStandardTagKeyId`,params);
  }
}

export default correctStandardTagValueConfiguration;



// WEBPACK FOOTER //
// ./src/api/correctStandardTagValueConfiguration.js